import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
  Typography,
  Box,
} from '@mui/material';
import { Close as CloseIcon } from '@mui/icons-material';

/**
 * Reusable history modal dialog wrapper.
 *
 * @param {boolean}       open      - Controls dialog visibility
 * @param {function}      onClose   - Close handler
 * @param {string|node}   title     - Dialog title
 * @param {node}          children  - Dialog content
 * @param {string}        maxWidth  - MUI Dialog maxWidth (default: 'xl')
 * @param {string}        height    - Dialog height (default: '80vh')
 * @param {node}          actions   - Custom actions; defaults to Close button
 */
const HistoryModal = ({
  open,
  onClose,
  title,
  children,
  maxWidth = 'xl',
  height = '80vh',
  actions,
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={maxWidth}
      fullWidth
      PaperProps={{
        sx: {
          height,
          maxHeight: height,
        },
      }}
    >
      <DialogTitle
        sx={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          borderBottom: 1,
          borderColor: 'divider',
          pb: 1,
        }}
      >
        <Typography variant="h6">{title}</Typography>
        <IconButton onClick={onClose} size="small" sx={{ color: 'grey.500' }}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent
        sx={{ p: 2, display: 'flex', flexDirection: 'column', height: '100%' }}
      >
        <Box sx={{ flex: 1, minHeight: 0, display: 'flex', flexDirection: 'column' }}>
          {children}
        </Box>
      </DialogContent>

      <DialogActions sx={{ p: 2, borderTop: 1, borderColor: 'divider' }}>
        {actions || (
          <Button onClick={onClose} variant="outlined">
            Close
          </Button>
        )}
      </DialogActions>
    </Dialog>
  );
};

export default HistoryModal;
